export const QUIZ = [
  {
    key: "smoking",
    label: "Smoking",
    question: "Do you smoke or vape?",
    span: "md:col-span-6",
    options: [
      { value: "never", title: "Never", desc: "Smoke-free living" },
      { value: "occasionally", title: "Socially", desc: "Now and then" },
      { value: "regularly", title: "Regularly", desc: "Most days" },
    ],
  },
  {
    key: "sleep",
    label: "Sleep",
    question: "How much do you sleep?",
    span: "md:col-span-6",
    options: [
      { value: "good", title: "7–9 hrs", desc: "Well rested" },
      { value: "ok", title: "6–7 hrs", desc: "Could be better" },
      { value: "poor", title: "Under 6", desc: "Running low" },
    ],
  },
  {
    key: "sun",
    label: "Sun Care",
    question: "Do you wear SPF?",
    span: "md:col-span-4",
    options: [
      { value: "always", title: "Daily", desc: "Every day" },
      { value: "sometimes", title: "Sometimes", desc: "Sunny days" },
      { value: "rarely", title: "Rarely", desc: "Almost never" },
    ],
  },
  {
    key: "diet",
    label: "Diet",
    question: "How do you eat?",
    span: "md:col-span-4",
    options: [
      { value: "whole", title: "Whole foods", desc: "Fresh & clean" },
      { value: "mixed", title: "Mixed", desc: "A bit of both" },
      { value: "processed", title: "Processed", desc: "Convenience" },
    ],
  },
  {
    key: "water",
    label: "Hydration",
    question: "Water per day?",
    span: "md:col-span-4",
    options: [
      { value: "high", title: "8+ glasses", desc: "Well hydrated" },
      { value: "medium", title: "4–7", desc: "Moderate" },
      { value: "low", title: "Under 4", desc: "Not enough" },
    ],
  },
  {
    key: "exercise",
    label: "Movement",
    question: "How often do you move?",
    span: "md:col-span-6",
    options: [
      { value: "high", title: "5+ / week", desc: "Very active" },
      { value: "moderate", title: "2–4 / week", desc: "Fairly active" },
      { value: "rare", title: "Rarely", desc: "Mostly still" },
    ],
  },
  {
    key: "stress",
    label: "Stress",
    question: "Your stress levels?",
    span: "md:col-span-6",
    options: [
      { value: "low", title: "Low", desc: "Pretty calm" },
      { value: "medium", title: "Medium", desc: "Ups & downs" },
      { value: "high", title: "High", desc: "Always on" },
    ],
  },
];
